import { createAction } from '@reduxjs/toolkit';

const clearCreateNewOrder = createAction('clearCreateNewOrder');
export const setCreateNewOrderData = createAction('setCreateNewOrderData');
export const setCreateNewOrderStep = createAction('setCreateNewOrderStep');
export default clearCreateNewOrder;
